<template>
  <div class="home">
    <van-nav-bar
      :title="$t('PackageDetail.title')"
      left-arrow
      fixed
      :z-index="9"
      @click-left="$router.push('/Dishes')"
    >
    </van-nav-bar>
    <div v-if="detail" style="padding-top:46px">
      <van-image
        v-if="detail.image"
        width="100%"
        fit="contain"
        :src="detail.image.path"
      />
      <div style="height: 3px;width: 100%;background-color: #F3F5F7;"></div>
      <div class="info">
        <div
          class="noExceed"
          style="height: 30px;font-size: 16px;line-height: 30px;"
        >
          {{ detail.name }}
        </div>
        <div class="noExceed" style="font-size: 16px;line-height:16px;">
          {{ detail.name_en }}
        </div>
        <p
          style="font-size: 14px;color: #666;padding: 0;margin-bottom: 10px;margin-top: 10px;word-break: break-all;"
        >
          {{ detail.introduction }}
        </p>
        <van-rate
          style="height: 16px;"
          v-model="detail.level"
          readonly
          :size="16"
          gutter="3px"
          icon="./static/img/Recommend-s.png"
          void-icon="./static/img/Recommend.png"
        />
        <div class="fontLine">
          <span class="currentPrice"
            >{{ sessionStorage.getItem("currency") }}
            {{
              detail.type == "o" ? detail.original_price : detail.special_price
            }}</span
          >&nbsp;&nbsp;&nbsp;<span class="oldPrice" v-show="detail.type == 's'"
            >{{ sessionStorage.getItem("currency")
            }}{{ detail.original_price }}</span
          >
        </div>
      </div>

      <div class="dishList" v-if="detail.tags && detail.tags.data">
        <template v-for="(tag, index) in detail.tags.data">
          <div style="height: 3px;width: 100%;background-color: #F3F5F7;"></div>
          <div class="dishItem" v-if="tag.menus.length > 0">
            <div class="dishTitle noExceed">
              {{ tag.name }}
            </div>
            <div class="dishChild" v-for="(menu, key) in tag.menus">
              <template v-if="tag.is_choiced == 1">
                <van-image
                  v-if="menu.image"
                  class="noflex"
                  :class="isSelectImg(index, key)"
                  width="42"
                  height="100%"
                  fit="contain"
                  :src="menu.image.path"
                  @click="changeChildDish(index, menu.target_id, key, 0)"
                />
                <van-image
                  v-else
                  class="noflex"
                  width="42"
                  height="100%"
                  fit="contain"
                  src=""
                  @click="changeChildDish(index, menu.target_id, key, 0)"
                />
              </template>
              <template v-else>
                <van-image
                  v-if="menu.image"
                  class="noflex"
                  :class="[
                    checkMenuIndex[index] == key ? 'actChild' : 'childImg'
                  ]"
                  width="42"
                  height="100%"
                  fit="contain"
                  :src="menu.image.path"
                  @click="changeChildDish(index, menu.target_id, key, 0)"
                />
                <van-image
                  v-else
                  class="noflex"
                  width="42"
                  height="100%"
                  fit="contain"
                  src=""
                  @click="changeChildDish(index, menu.target_id, key, 0)"
                />
              </template>
              <div class="childTitle">
                <div
                  class="childTitle1 noExceed"
                  @click="changeChildDish(index, menu.target_id, key)"
                >
                  {{ menu.name }}
                </div>
                <div class="childTitle1 noExceed">
                  {{ menu.name_en ? menu.name_en : "  " }}
                </div>
              </div>
              <div style="float: right;margin-right:5px">
                {{ sessionStorage.getItem("currency") }}{{ menu.fill_price }}
              </div>
              <!-- Ernest 要求没有偏好设置的不显示按钮 -->
              <template v-if="menu.perfer.length > 0">
                <div class="tasteBtn fr" @click="showTaste(index, key)">
                  <img
                    src="../../static/img/Option.png"
                    style="width:50px;height:32px"
                  />
                </div>
              </template>
              <template v-else>
                <div class="tasteBtn fr" style="opacity: 0;">
                  <img
                    src="../../static/img/Option.png"
                    style="width:50px;height:32px"
                  />
                </div>
              </template>
              <template v-if="tag.is_choiced == 1">
                <van-icon
                  class="selChild"
                  v-if="checkMenuIndex[index].indexOf(key) != -1"
                  name="./static/img/sele_food.png"
                  size="18px"
                />
              </template>
              <template v-else>
                <van-icon
                  class="selChild"
                  v-if="checkMenuIndex[index] == key"
                  name="./static/img/sele_food.png"
                  size="18px"
                />
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div style="height: 50px;background: #F3F5F7;"></div>
    <van-popup
      v-model="isTasteShow"
      position="bottom"
      :style="{ height: '75%' }"
    >
      <van-cell-group>
        <van-cell>
          <div style="font-size: 16px;" slot="title">
            {{ $t("PackageDetail.note") }}
          </div>
          <van-icon
            slot="right-icon"
            name="./static/img/dele_staff.png"
            size="26px"
            @click="isTasteShow = false"
          />
        </van-cell>
      </van-cell-group>
      <div v-if="actPerfer" class="tasteGropu">
        <template v-for="(item, index) in actPerfer">
          <div class="tasteItem" v-if="item.category.data.length > 0">
            <div class="tasteItemTitle">{{ item.name }}</div>
            <div
              v-for="(val, key) in item.category.data"
              class="tasteItemRadio"
              :class="[
                childResult[index] == val.id ? 'tasteItemRadio_act' : ''
              ]"
              @click="changeResult(index, val.id)"
            >
              {{ val.name }}
            </div>
          </div>
        </template>
        <div class="tasteItem">
          <div class="tasteItemTitle">{{ $t("PackageDetail.remark") }}</div>
          <van-field
            v-model="actRemark"
            rows="3"
            autosize
            type="textarea"
            maxlength="80"
            :placeholder="$t('PackageDetail.inputRemark')"
            show-word-limit
            style="text-indent: 10px;border:1px solid #2f75f4;border-radius: 5px;"
          />
        </div>
      </div>
      <div style="width: 100%;height: 50px;">
        <van-button
          style="width: 90%;height: 35px;margin-left: 5%;margin-top: 7px;line-height: 35px;"
          color="#2f75f4"
          round
          @click="saveChange()"
          >{{ $t("PackageDetail.certain") }}</van-button
        >
      </div>
    </van-popup>

    <van-tabbar class="flexNone" style="background: #000;">
      <div style="width: 88%;height: 34px;margin:8px 6%;">
        <div class="cart_right">
          <van-button
            color="#2f75f4"
            class="cart_right_btn fr"
            round
            @click="addCart()"
            >{{ $t("PackageDetail.certain") }}</van-button
          >
        </div>
      </div>
    </van-tabbar>
    <div
      class="inDot"
      :style="{ bottom: bottomNum + 'px', left: leftNum + 'px' }"
      v-show="visible"
    ></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
      isTasteShow: false,
      actPerfer: [],
      actRemark: "",

      menus_id: [],
      checkMenuIndex: [],
      tags_id: [],
      fill_price: [],
      remarks: [],
      perferResult: [],
      childResult: [],
      actIndex: "",
      actIndexKey: "",
      //动效 声音
      visible: false,
      bottomNum: 33,
      leftNum: 50,
      musicPlayer: new Audio()
    };
  },
  mounted: function() {
    // this.menus_id = editPackage.menus_id;
    // this.tags_id = editPackage.tags_id;
    // this.fill_price = editPackage.fill_price;
    // this.remarks = editPackage.remark;

    // menus_id:menus_id,
    // tags_id:(perferResult),
    // remark:(remarks),
    // fill_price:(this.fill_price),

    this.getPackageDetail();
    this.musicPlayer.src = "./static/music/add_dish.mp3";
    this.musicPlayer.loop = false;
    this.musicPlayer.preload = "auto";
  },
  computed: {
    isSelectImg() {
      return function(index, key) {
        if (this.checkMenuIndex[index].length > 0) {
          console.log(this.checkMenuIndex[index]);
          return this.checkMenuIndex[index].indexOf(key) != -1
            ? "actChild"
            : "childImg";
        }
      };
    }
  },
  methods: {
    getPackageDetail() {
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build + "/api/menu/" + this.$route.params.id + "/customerIndex"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.detail = res.data.data;

            // var editPackage = JSON.parse(sessionStorage.editPackage);
            // var editPackage = {
            //     fill_price: "[[0,0],0,0]",
            //     menu_id: "134",
            //     menus_id: "[[297,550],550,119]",
            //     place_id: "146",
            //     remark: "[[\"\",\"\"],\"\",\"\"]",
            //     tags_id: "[[[347,342],[]],[],[347,343]]",
            // };
            for (var i = 0; i < this.detail.tags.data.length; i++) {
              if (this.detail.tags.data[i].is_choiced == 1) {
                if (this.detail.tags.data[i].menus.length > 0) {
                  var tagkey = [];
                  for (
                    var k = 0;
                    k < this.detail.tags.data[i].menus.length;
                    k++
                  ) {
                    var old_menuid = JSON.parse(editPackage.menus_id);
                    if (
                      old_menuid[i].indexOf(
                        this.detail.tags.data[i].menus[k].target_id
                      ) != -1
                    ) {
                      tagkey.push(k);
                      continue;
                    }
                  }
                  this.checkMenuIndex.push(tagkey);
                }
              } else {
                this.checkMenuIndex.push(0);
              }
            }
            console.log(this.checkMenuIndex);
            this.fill_price = JSON.parse(editPackage.fill_price);
            this.perferResult = JSON.parse(editPackage.tags_id);
            this.remarks = JSON.parse(editPackage.remark);
            this.menus_id = JSON.parse(editPackage.menus_id);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    showTaste(index, key) {
      this.actIndex = index;
      this.actIndexKey = key;

      if (this.detail.tags.data[index].is_choiced == 1) {
        this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
        this.actRemark = this.remarks[index][key]
          ? this.remarks[index][key]
          : "";
        this.childResult = this.perferResult[index][key]
          ? this.perferResult[index][key]
          : [];
        this.isChoiced = 1;
      } else {
        this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
        this.actRemark = this.remarks[index] ? this.remarks[index] : "";
        this.childResult = this.perferResult[index]
          ? this.perferResult[index]
          : [];
        this.isChoiced = 0;
      }
      this.isTasteShow = true;
      // this.actIndex=index;
      // this.actPerfer=this.detail.tags.data[index].menus[key].perfer;
      // this.actRemark=this.remarks[index];
      // this.childResult=this.perferResult[index];
      // this.isTasteShow=true;
    },
    changeResult(index, id) {
      this.$set(this.childResult, index, id);
    },
    addCart() {
      var tmenuids = [];
      var tremarks = [];
      var tperferResult = [];
      for (var i = 0; i < this.menus_id.length; i++) {
        if (this.menus_id[i].id) {
          tmenuids.push(this.menus_id[i].id);
          tremarks.push(this.remarks[i]);
          tperferResult.push(this.perferResult[i]);
        }
      }
      var perferIds = [];
      perferIds.push(this.perferResult);
      var data = {
        menu_id: this.$route.params.id,
        menus_id: JSON.stringify(tmenuids),
        tags_id: JSON.stringify(tperferResult),
        remark: JSON.stringify(tremarks),
        fill_price: JSON.stringify(this.fill_price)
      };
      console.log(data);
      this.$axios({
        method: "post",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/shopcart/" +
          this.$route.params.id +
          "/customerCart",
        data: {
          menu_id: this.$route.params.id,
          menus_id: JSON.stringify(tmenuids),
          tags_id: JSON.stringify(tperferResult),
          remark: JSON.stringify(tremarks),
          fill_price: JSON.stringify(this.fill_price)
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.addAnimation();
            this.musicPlayer.currentTime = 0;
            this.musicPlayer.play();
            const vm = this;
            setTimeout(function() {
              vm.$router.push("/Dishes");
            }, 1000);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    changeChildDish(index, id, key, type) {
      console.log(this.detail.tags.data[index].menus);
      console.log(this.checkMenuIndex[index]);
      if (this.detail.tags.data[index].is_choiced == 0) {
        this.menus_id[index].id = id;
        this.$set(this.checkMenuIndex, index, key);
        this.fill_price[index] = this.detail.tags.data[index].menus[
          key
        ].fill_price;
      } else {
        // 点击修改选择单品
        var arr = [];
        if (typeof this.checkMenuIndex[index] == "number") {
          arr.push(this.checkMenuIndex[index]);
          var i = arr.indexOf(key);
          if (i == -1) {
            arr.push(key);
          } else {
            if (arr.length > 1) {
              arr.splice(i, 1);
            }
          }
        } else {
          arr = this.checkMenuIndex[index];
          if (type == 1) {
            var i = arr.indexOf(key);
            if (i == -1) {
              arr.push(key);
            }
          } else {
            var i = arr.indexOf(key);
            if (i == -1) {
              arr.push(key);
            } else {
              if (arr.length > 1) {
                arr.splice(i, 1);
              }
            }
          }
        }
        this.$set(this.checkMenuIndex, index, arr);
        var arrId = [],
          priceId = [];
        for (var j in arr) {
          arrId.push(this.detail.tags.data[index].menus[arr[j]].target_id);
          priceId.push(this.detail.tags.data[index].menus[arr[j]].fill_price);
        }
        this.menus_id[index].id = arrId;
        this.fill_price[index] = priceId;
      }
      // 点击修改选择单品
      // this.menus_id[index].id=id;
      // this.$set(this.checkMenuIndex,index,key);
      // this.fill_price[index]=this.detail.tags.data[index].menus[key].fill_price;
    },
    saveChange() {
      if (this.isChoiced == 1) {
        this.$set(
          this.remarks[this.actIndex],
          this.actIndexKey,
          this.actRemark
        );
        this.$set(
          this.perferResult[this.actIndex],
          this.actIndexKey,
          this.childResult
        );
        this.changeChildDish(
          this.actIndex,
          this.detail.tags.data[this.actIndex].menus[this.actIndexKey]
            .target_id,
          this.actIndexKey,
          1
        );
      } else {
        this.$set(this.remarks, this.actIndex, this.actRemark);
        this.$set(this.perferResult, this.actIndex, this.childResult);
      }
      this.isTasteShow = false;
      this.actRemark = "";
      this.childResult = [];
      // this.$set(this.remarks,this.actIndex,this.actRemark);
      // this.$set(this.perferResult,this.actIndex,this.childResult);
      // this.isTasteShow=false;
      // this.actRemark='';
      // this.childResult=[];
    },
    addAnimation() {
      this.visible = true;
      this.bottomNum = 33;
      this.leftNum = 250;
      var that = this;
      var timer = setInterval(function() {
        if (that.leftNum > 150 && that.bottomNum < 133) {
          that.bottomNum += 5;
        } else if (that.leftNum <= 150 && that.bottomNum > 33) {
          that.bottomNum -= 5;
        } else {
          that.bottomNum = 33;
          that.visible = false;
          clearInterval(timer);
        }
        if (that.leftNum > 50) {
          that.leftNum -= 5;
        } else {
          that.leftNum = 50;
        }
      }, 10);
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #ffc813;
}
/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .van-info {
  border-color: #000;
}
.home {
  width: 100%;
  height: auto;
  background-color: #fff;
}
.currentPrice {
  font-size: 18px;
  color: #ff6666;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.info {
  width: 90%;
  margin-left: 5%;
  height: auto;
  position: relative;
}
.fontLine {
  padding-bottom: 10px;
  font-size: 14px;
}
.setPerfer {
  position: absolute;
  width: 35px;
  height: 35px;
  bottom: 10px;
  right: 0px;
}
.flexNone {
  flex: none;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  font-size: 18px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 34px;
  margin: 0 auto;
}
.cart_right_btn {
  width: 100%;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
}
.total_price {
  height: 34px;
  line-height: 34px;
  font-size: 20px;
  text-indent: 10px;
  color: #fff;
}
.tasteGropu {
  width: 90%;
  margin-left: 5%;
  font-size: 16px;
  height: auto;
}
.tasteItem {
  width: 100%;
  height: auto;
  color: #222;
}
.tasteItemTitle {
  width: 100%;
  height: 45px;
  line-height: 45px;
}
.tasteItemRadio {
  width: 100%;
  height: 33px;
  line-height: 33px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #2f75f4;
  text-indent: 10px;
  margin-bottom: 20px;
  color: #000;
}
.tasteItemRadio_act {
  background-color: #2f75f4;
  color: #fff;
}
.dishList {
  width: 100%;
  min-height: 80px;
  font-size: 14px;
  margin-bottom: 50px;
}
.dishItem {
  width: 90%;
  margin-left: 5%;
  min-height: 80px;
}
.dishTitle {
  width: 100%;
  height: 36px;
  line-height: 36px;
}
.dishChild {
  width: 100%;
  height: 42px;
  line-height: 42px;
  padding-bottom: 5px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  z-index: 1;
}
.childTitle {
  flex: auto;
  height: 42px;
  text-indent: 10px;
  width: 100px;
}
.childTitle1 {
  width: 100%;
  height: 20px;
  line-height: 20px;
}
.selChild {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 2;
}
.actChild {
  border: 0.125rem solid #2f75f4;
  border-radius: 0.1875rem;
}
.childImg {
  border: 0.125rem solid #ddd;
  border-radius: 0.1875rem;
}
.van-button__text {
  color: #fff;
}
.icontext {
  position: absolute;
  font-size: 14px;
  right: 0px;
}
/*购物车样式*/
.cartDetail {
  width: 100%;
  height: auto;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.cart_dish {
  width: 100%;
}
.cart_dish_name {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.son_dish {
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  padding-top: 10px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  clear: both;
}
.realPrice {
  color: #000;
}
.inDot {
  width: 24px;
  height: 24px;
  background: #ee0a24;
  border-radius: 50%;
  position: fixed;
  z-index: 2;
}
.tasteBtn {
  width: 50px;
  height: 32px;
  /* background:url('/static/img/Option.png'); */
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/PackageEdit.vue